<div class="modal">
  <div class="modal-close">
    <img
      (click)="close()"
      class="close-icon"
      src="assets/images/close.png"
      alt="close icon"
    />
  </div>
  <div class="modal-header">
    <img class="icon" [src]="assetPath" alt="information icon" />
    <span class="blue-text">{{ title }}</span>
  </div>
  <div class="modal-body">
    <div>
      <span
        *ngFor="let text of arrayText; let index = index"
        class="gray-text"
        [ngClass]="{ bold: index % 2 != 0 }"
      >
        {{ text }}</span
      >
    </div>
    <div [innerHTML]="html">
      
    </div>
    <div class="upload" *ngIf="requestDocument">
      <span class="gray-text">Si tienes el documento, </span
      ><span class="link bold" (click)="openFileInput()">adjuntar aquí.</span>
    </div>
    <input
      type="file"
      #fileInput
      accept=".jpg,.jpeg,.png,.pdf"
      style="display: none"
      (change)="onFileSelected($event)"
    />
    <div *ngIf="selectPay"> 
      <br>
      <br>
      <form [formGroup]="formulario">
        <div style="display: flex; justify-content: space-evenly; align-items: center;">
          <label style="margin-right: 20px;">
            <input type="radio" formControlName="opcion" value="getnet">
            <img src="https://www.9mm.cl/wp-content/uploads/2023/06/getnet-logo.png" alt="Getnet">
            
          </label>
    
          <label>
            <input type="radio" formControlName="opcion" value="khipu">
            <img src="https://jumpseller.es/generated/images/gateways/gateway_khipu-600-130334f0b.jpg" alt="Khipu">
            </label>
        </div>
        <br>
        <div *ngIf="formulario.controls['opcion'].invalid && formulario.controls['opcion'].touched">
          <p style="color: red;">Debes seleccionar una opción.</p>
        </div>
        <br>
      </form>
    </div>
    



  </div>

  <div class="modal-footer">
    <button
      *ngIf="hasSecondaryButton"
      class="bsa-white-button"
      (click)="close()"
    >
      Volver
    </button>
    <button *ngIf="hasPrimaryButton && !selectPay" class="bsa-button" (click)="accept()">
      Aceptar
    </button>
    <button [disabled]="formulario.invalid" *ngIf="hasPrimaryButton && selectPay" class="bsa-button" (click)="accept()">
      Aceptar
    </button>
  </div>
</div>
<ng-template #uploadModal>
  <upload-file-modal></upload-file-modal>
</ng-template>
